import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PageListComponent } from './components/main-list-carrier.component/main-list-carrier.component';

const routes: Routes = [
  {
    path: '',
    component: PageListComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CarriersRoutingModule {}
